module.exports = __webpack_public_path__ + "img/content_bg.c669ce20.png";